<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    import MarkerClusterer from '@google/markerclusterer';

  export default {
    name: "map-cluster",
    props: ['map', 'markers', 'image'],
    data() {
      return {
        googleCluster: null,
        reloadMarkersTimeout: null
      }
    },
    watch: {
      map(map) {
        this.createCluster(map)
      },
      markers(markers, oldMarkers) {
        clearTimeout(this.reloadMarkersTimeout);
        this.reloadMarkersTimeout = setTimeout(() => {
          if(this.googleCluster) {
            this.googleCluster.removeMarkers(oldMarkers);
            this.googleCluster.addMarkers(markers)
          }
        }, 100);

        // for(let marker of markers) {
        //   marker.addListener('visible_changed', () => {
        //     if(marker.getVisible()) {
        //       this.googleCluster.addMarker(marker);
        //     }else {
        //       this.googleCluster.removeMarker(marker);
        //     }
        //   })
        // }
      },
      // TODO: Wyciągnąć to z pluginu
      '$store.state.selectedPromotions'() {

        this.googleCluster.removeMarkers(this.markers);

        this.$nextTick(() => {
          let markersToShow = this.markers.filter(marker => {
            return marker.getVisible();
          })
          this.googleCluster.addMarkers(markersToShow)
        })

      }
    },
    computed: {
      googleMarkers() {
        if(this.$slots.default && this.$slots.default.length && this.$slots.default[0].markerElement) {
          return this.$slots.default.map(component => {
            return component.markerElement;
          })
        }else {
          return this.markers;
        }
      },
      imagePath() {
        if(this.image) return this.image;
        return 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
      }
    },
    mounted() {
      // console.log(this.googleMarkers)
    },
    methods: {
      createCluster(map) {
        this.$googleApiPromise.then(google => {
          this.googleCluster = new MarkerClusterer(map, this.googleMarkers, {
            imagePath: this.imagePath,
            gridSize: 0,
            styles: [
              {
                width: 54,
                height: 54,
                url: this.image,
                backgroundPosition: '50% 50%',
                textColor: '#FFF'
              }
            ]
          })

          this.googleCluster.setCalculator(function(markers, numStyles) {
            var index = 0;
            markers = markers.filter(marker => {
              return marker.getVisible();
            })
            var count = markers.length;

            if(! count && this) {
              this.setMap(null)
              return;
            }
            var dv = count;
            while (dv !== 0) {
              dv = parseInt(dv / 10, 10);
              index++;
            }

            index = Math.min(index, numStyles);
            return {
              text: count,
              index: index
            };
          })

          this.$emit('clusterCreated', this.googleCluster)
        })
      }
    }
  }
</script>

<style scoped>

</style>